hrd.charts.Factory = function(options, chartData, customChartOptions, customImpl){
	if(customImpl == undefined){
	switch (chartData.type) {
	case 'bar':
		return new hrd.charts.BarChart(options, chartData, customChartOptions);
	case 'pie':
		return new hrd.charts.PieChart(options, chartData, customChartOptions);
	case 'donut':
		return new hrd.charts.DonutChart(options, chartData, customChartOptions);
	case 'line':
		return new hrd.charts.LineChart(options, chartData, customChartOptions);
	case 'area':
		return new hrd.charts.AreaChart(options, chartData, customChartOptions);
	case 'gauge':
		return new hrd.charts.GaugeChart(options, chartData, customChartOptions);
	case 'scatter':
		return new hrd.charts.ScatterChart(options, chartData, customChartOptions);
	case 'combined':
		return new hrd.charts.CombinedChart(options, chartData, customChartOptions);
	default:
		console.log('Chart of type', chartData.type, 'not yet implemented');
			return new hrd.charts.AbstractChart(options, chartData, customChartOptions);
		}
	} else {
		var customImplClass = $.evaluate(customImpl);
		if (customImplClass != undefined){
			return $.evaluate('new impl(options, chartData, customChartOptions)', this, [customImplClass, options, chartData, customChartOptions], ['impl', 'options', 'chartData', 'customChartOptions']);
		} else {
			console.log('Chart of custom type', customImpl, 'not available');
			return new hrd.charts.AbstractChart(options, chartData, customChartOptions);
		}
	}
}